import React, { useState } from 'react';
import { useAlert } from '../context/AlertContext';
import { urlApi } from '../helpers/functionHelpers';
import '../styles/RegistroLlegada.css'; // We will create this

const RegistroLlegada = () => {
  const { mostrarAlerta } = useAlert();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    folio: '',
    estado: 'A Tiempo',
    tipoRechazo: 'Rechazo Total',
    motivoRechazo: ''
  });

  const motivosRechazo = [
    "No trajo Orden de Compra",
    "Falta certificado de fumigación",
    "No cuenta con EPP (chaleco, botas, etc.)",
    "Mercancía dañada",
    "Cita no encontrada o incorrecta",
    "Placas no coinciden",
    "Fuera de horario permitido",
    "Otros"
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.estado === 'Rechazado' && !formData.motivoRechazo) {
      mostrarAlerta("Debe seleccionar un motivo de rechazo", "error");
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${urlApi}/api/llegadas/registrar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          folio: formData.folio,
          estado: formData.estado,
          tipo_rechazo: formData.tipoRechazo,
          motivo_rechazo: formData.motivoRechazo
        })
      });

      if (!response.ok) {
        throw new Error("Error al registrar la llegada");
      }

      mostrarAlerta("Llegada registrada exitosamente", "success");
      setFormData({
        folio: '',
        estado: 'A Tiempo',
        tipoRechazo: 'Rechazo Total',
        motivoRechazo: ''
      });
    } catch (err) {
      mostrarAlerta(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="registro-llegada-container">
      <div className="registro-llegada-card">
        <h2>Registro de Llegada</h2>
        <p className="subtitle">Módulo para guardias / caseta de seguridad</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="folio">Folio de Cita (Opcional si no tiene cita)</label>
            <input
              type="text"
              id="folio"
              name="folio"
              value={formData.folio}
              onChange={handleChange}
              placeholder="Ej: FOLIO-12345"
            />
          </div>

          <div className="form-group">
            <label htmlFor="estado">Estado de Llegada</label>
            <select
              id="estado"
              name="estado"
              value={formData.estado}
              onChange={handleChange}
            >
              <option value="A Tiempo">A Tiempo</option>
              <option value="Fuera de Tiempo">Fuera de Tiempo</option>
              <option value="Sin Cita">Sin Cita (Llegó sin agendar)</option>
              <option value="Rechazado">Rechazado (No se permite ingreso)</option>
            </select>
          </div>

          {formData.estado === 'Rechazado' && (
            <div className="rechazo-section">
              <div className="form-group">
                <label htmlFor="tipoRechazo">Tipo de Rechazo</label>
                <select
                  id="tipoRechazo"
                  name="tipoRechazo"
                  value={formData.tipoRechazo}
                  onChange={handleChange}
                >
                  <option value="Rechazo Total">Rechazo Total</option>
                  <option value="Rechazo Parcial">Rechazo Parcial</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="motivoRechazo">Motivo del Rechazo</label>
                <select
                  id="motivoRechazo"
                  name="motivoRechazo"
                  value={formData.motivoRechazo}
                  onChange={handleChange}
                >
                  <option value="">Seleccione un motivo...</option>
                  {motivosRechazo.map((motivo, index) => (
                    <option key={index} value={motivo}>{motivo}</option>
                  ))}
                </select>
              </div>
            </div>
          )}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Registrando..." : "Registrar Llegada"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegistroLlegada;
